import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { inject, onMounted, ref } from "vue";
import { FileServiceSymbol } from "@/InjectionSymbols";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ProductPreviewComponent',
    props: {
        product: {
            type: Object,
            required: true
        }
    },
    setup(__props) {
        const props = __props;
        const fileService = inject(FileServiceSymbol);
        let imageUrl = ref(require('@/assets/productPlaceholder.png'));
        onMounted(async () => {
            const image = props.product?.image;
            if (image) {
                const imageSrc = await fileService.getImageSrc(image);
                if (imageSrc && imageSrc.length > 0) {
                    imageUrl.value = imageSrc;
                }
            }
        });
        return (_ctx, _cache) => {
            const _component_v_img = _resolveComponent("v-img");
            const _component_v_card_title = _resolveComponent("v-card-title");
            const _component_v_card_subtitle = _resolveComponent("v-card-subtitle");
            const _component_v_card_text = _resolveComponent("v-card-text");
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_card_actions = _resolveComponent("v-card-actions");
            const _component_v_card = _resolveComponent("v-card");
            return (_openBlock(), _createBlock(_component_v_card, {
                width: "380",
                "data-cy": "productPreview",
                class: "d-flex flex-column"
            }, {
                default: _withCtx(() => [
                    _createVNode(_component_v_img, {
                        src: _unref(imageUrl),
                        height: "200px",
                        "max-height": "200px",
                        cover: true
                    }, null, 8, ["src"]),
                    _createVNode(_component_v_card_title, { class: "text-start pb-0" }, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(__props.product.title), 1)
                        ]),
                        _: 1
                    }),
                    _createVNode(_component_v_card_subtitle, {
                        class: "text-start",
                        style: { "min-height": "1lh" }
                    }, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(__props.product.subtitle), 1)
                        ]),
                        _: 1
                    }),
                    _createVNode(_component_v_card_text, { class: "d-flex justify-start text-start" }, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(__props.product.shortDescription), 1)
                        ]),
                        _: 1
                    }),
                    _createVNode(_component_v_card_actions, { class: "d-flex justify-center" }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_btn, {
                                onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$router.push({ name: 'product', params: { id: __props.product.id } }))),
                                variant: "outlined"
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(__props.product.priceStructure.displayPrice), 1)
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    })
                ]),
                _: 1
            }));
        };
    }
});
